/**************************************************
 * Nombre:       Home_Blog
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloApartados from "./SubComponentes/TituloApartados";
import Tarjeta_Blog from "../../Tarjetas/Tarjeta_Blog";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Home_Blog = () => {
    const cData = useContext(contexApp)
    const [blogs, setBlogs] = useState([])

    useEffect(() =>{

        if(cData.blogs){
            setBlogs(cData.blogs)
        }

    },[cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <TituloApartados titulo={'Ideas y Recursos Para'} inicio={'NUESTRO BLOG'}
                                         negrita={'La Salud Emocional'}
                                         postitulo={''}
                                         frase={'Guias Practicas y Recursos de Apoyo'}/>
                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={5}
                        sx={{mt: 8}}
                    >

                        {blogs.map(item => (
                            <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Blog item={item}/>
                            </Grid>
                        ))}

                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Blog
